export type VisibilityState = Record<string, boolean>;

export const videoViewCountColumnVisibility: VisibilityState = {
  slNo: true,
  id: true,
  user_id: true,
  video_id: true,
  count: true,
};
